module.exports = __webpack_public_path__ + "img/taxation.00e2927e.png";